import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Template name")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Choose base template")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Description")
], -1)
const _hoisted_4 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.arTemplateData
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_form_item, {
        ref: "name",
        name: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            type: "text",
            value: _ctx.arTemplateData.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.arTemplateData.name) = $event)),
            placeholder: "Template name",
            class: "ant-input"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      (_ctx.method == 'Create')
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            name: "baseARTemplate"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_a_select, {
                defaultValue: "Choose base template",
                onChange: _ctx.setTemplate
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseARTemplates, (temp) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: temp.type,
                      value: temp.type
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(temp.type), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form_item, { name: "description" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_a_textarea, {
            class: "ant-input",
            placeholder: "Template decription",
            value: _ctx.arTemplateData.description,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.arTemplateData.description) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              style: {"margin-right":"10px"},
              type: "default",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              loading: _ctx.loading,
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}